import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarHoverAdminMasters(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);
    
    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="Master"?"":"Master")} title="Master" className={props.activeMenu == "Master" ? "sidenav-expanded-active pointer px-0 sidenavbar-text border-bottom" : "pointer px-0 sidenavbar-text border-bottom"}
                hidden={props.currentUserRolePermissionData?.includes("master:master:view")?false:true}>
                <span className="mx-2 sidenavbar-text">Masters
                    <i className={showMenu=="Master"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "Master" ? "multilevel-sidenav": "display-none"}>
                <a onClick={() => setShowSubMenu(showSubMenu=="AdminMaster"?"":"AdminMaster")} title="Admin Master" className={props.activeSubMenu == "AdminMaster" ? "sidenav-expanded-active pointer px-0" : "pointer px-0"}
                    hidden={props.currentUserRolePermissionData?.includes("master:master:view")?false:true}>
                    <span className="mx-1 px-3 sidenavbar-text">Admin Masters 
                        <i className={showMenu=="Master" && showSubMenu=="AdminMaster"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                    </span>
                </a>

                <ul className={showMenu=="Master" && showSubMenu=="AdminMaster"? "multilevel-sidenav-submenu": "display-none"}>
                    <a onClick={() => navigate("/master/admin/agent")} title="Agents" 
                    className={props.activeSubMenuLevel1 == "AgentMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:agent:view")?false:true}>
                        Agent
                    </a>

                    <a onClick={() => navigate("/master/admin/bankaccount")} title="Bank Account" 
                    className={props.activeSubMenuLevel1 == "BankAccountMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:bankaccount:view")?false:true}>
                        Bank Account
                    </a>

                    <a onClick={() => navigate("/master/admin/cfs")} title="CFS" 
                    className={props.activeSubMenuLevel1 == "CFSMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:cfs:view")?false:true}>
                        CFS
                    </a>

                    <a onClick={() => navigate("/master/admin/charges")} title="Charges" 
                    className={props.activeSubMenuLevel1 == "ChargesMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:charges:view")?false:true}>
                        Charges
                    </a>

                    <a onClick={() => navigate("/master/admin/currencyexchangerate")} title="Currency Exchange Rate" 
                    className={props.activeSubMenuLevel1 == "CurrencyExchangeRateMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:currencyexchangerate:view")?false:true}>
                        Currency Exchange Rate
                    </a>

                    <a onClick={() => navigate("/master/admin/depot")} title="Depot" 
                    className={props.activeSubMenuLevel1 == "DepotMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:depot:view")?false:true}>
                        Depot
                    </a>

                    <a onClick={() => navigate("/master/admin/message")} title="Message" 
                    className={props.activeSubMenuLevel1 == "MessageMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:message:view")?false:true}>
                        Message
                    </a>

                    <a onClick={() => navigate("/master/admin/notificationtemplategroup")} title="Notification Template Group" 
                    className={props.activeSubMenuLevel1 == "Notification Template Group Master" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:notificationtemplategroup:view")?false:true}>
                        Notification Template Group
                    </a>

                    <a onClick={() => navigate("/master/admin/operator")} title="Operator" 
                    className={props.activeSubMenuLevel1 == "OperatorMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:operator:view")?false:true}>
                        Operator
                    </a>

                    <a onClick={() => navigate("/master/admin/owner")} title="Owner" 
                    className={props.activeSubMenuLevel1 == "OwnerMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:owner:view")?false:true}>
                        Owner
                    </a>

                    <a onClick={() => navigate("/master/admin/port")} title="Port" 
                    className={props.activeSubMenuLevel1 == "PortMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:port:view")?false:true}>
                        Port
                    </a>

                    <a onClick={() => navigate("/master/admin/principal")} title="Principal" 
                    className={props.activeSubMenuLevel1 == "PrincipalMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:principal:view")?false:true}>
                        Principal
                    </a>

                    <a onClick={() => navigate("/master/admin/product")} title="Product" 
                    className={props.activeSubMenuLevel1 == "ProductMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:product:view")?false:true}>
                        Product
                    </a>

                    <a onClick={() => navigate("/master/admin/queue")} title="Queue" 
                    className={props.activeSubMenuLevel1 == "QueueMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:queue:view")?false:true}>
                        Queue
                    </a>

                    <a onClick={() => navigate("/master/admin/role")} title="Roles" 
                    className={props.activeSubMenuLevel1 == "RoleMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:role:view")?false:true}>
                        Role
                    </a>

                    <a onClick={() => navigate("/master/admin/rolepermission")} title="Role Permissions" 
                    className={props.activeSubMenuLevel1 == "RolePermissionMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:rolepermission:view")?false:true}>
                        Role Permission
                    </a>

                    <a onClick={() => navigate("/master/admin/salesteam")} title="Sales Team" 
                    className={props.activeSubMenuLevel1 == "SalesTeamMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:salesteam:view")?false:true}>
                        Sales Team
                    </a>
                    
                    <a onClick={() => navigate("/master/admin/surveyor")} title="Surveyor" 
                    className={props.activeSubMenuLevel1 == "SurveyorMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:surveyor:view")?false:true}>
                        Surveyor
                    </a>

                    <a onClick={() => navigate("/master/admin/task")} title="Tasks" 
                    className={props.activeSubMenuLevel1 == "TaskMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:task:view")?false:true}>
                        Tasks
                    </a>

                    <a onClick={() => navigate("/master/admin/terminalvendor")} title="Terminal Vendor" 
                    className={props.activeSubMenuLevel1 == "TerminalVendorMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:terminalvendor:view")?false:true}>
                        Terminal Vendor
                    </a>

                    <a onClick={() => navigate("/master/admin/uploadgroup")} title="Upload Group" 
                    className={props.activeSubMenuLevel1 == "UploadGroupMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:uploadgroup:view")?false:true}>
                        Upload Group
                    </a>

                    <a onClick={() => navigate("/master/admin/user")} title="Users" 
                    className={props.activeSubMenuLevel1 == "UserMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-submenu-text" : "pointer px-3 sidenavbar-submenu-text"}
                    hidden={props.currentUserRolePermissionData?.includes("master:user:view")?false:true}>
                        User
                    </a>
                </ul>
                
                <a onClick={() => navigate("/master/cargoname")} title="Cargo Name" 
                className={props.activeSubMenu == "CargoNameMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:cargoname:view")?false:true}>
                    Cargo Names
                </a>

                <a onClick={() => navigate("/master/customer")} title="Customer" 
                className={props.activeSubMenu == "CustomerMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:customer:view")?false:true}>
                    Customer
                </a>

                <a onClick={() => navigate("/master/customerbranch")} title="Customer Branch" 
                className={props.activeSubMenu == "CustomerBranchMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:customer:view")?false:true}>
                    Customer Branch
                </a>

                <a onClick={() => navigate("/master/deadfreightvessel")} title="Dead Freight Vessel" 
                className={props.activeSubMenu == "DeadFreightVesselMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:deadfreightvessel:view")?false:true}>
                    Dead Freight Vessel
                </a>

                <a onClick={() => navigate("/master/packagetype")} title="Package" 
                className={props.activeSubMenu == "PackageMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:package:view")?false:true}>
                    Package
                </a>

                <a onClick={() => navigate("/master/project")} title="Project" 
                className={props.activeSubMenu == "ProjectMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:project:view")?false:true}>
                    Project
                </a>

                <a onClick={() => navigate("/master/vessel")} title="Vessels" 
                className={props.activeSubMenu == "VesselMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:vessel:view")?false:true}>
                    Vessels
                </a>

                <a onClick={() => navigate("/master/vesselschedule")} title="Vessel Schedule" 
                className={props.activeSubMenu == "VesselSchedule" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:vesselschedule:view")?false:true}>
                    Vessel Schedule
                </a>

                <a onClick={() => navigate("/master/vesselservice")} title="Vessel Service"
                className={props.activeSubMenu == "VesselServiceMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:vesselservice:view")?false:true}>
                    Vessel Service
                </a>

                <a onClick={() => navigate("/master/department")} title="Department"
                className={props.activeSubMenu == "DepartmentMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:department:view")?false:true}>
                    Department
                </a>

                <a onClick={() => navigate("/master/designation")} title="Designation"
                className={props.activeSubMenu == "DesignationMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:designation:view")?false:true}>
                    Designation
                </a>

                <a onClick={() => navigate("/master/assettype")} title="Asset Type"
                className={props.activeSubMenu == "AssetTypeMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:assettype:view")?false:true}>
                    Asset Type
                </a>

                <a onClick={() => navigate("/master/holiday")} title="Holiday"
                className={props.activeSubMenu == "HolidayMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:holiday:view")?false:true}>
                    Holiday
                </a>

                <a onClick={() => navigate("/master/leavetype")} title="Leave Type"
                className={props.activeSubMenu == "LeaveTypeMaster" ? "sidenav-expanded-active pointer px-3 sidenavbar-text" : "pointer px-3 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("master:leavetype:view")?false:true}>
                    Leave Type
                </a>
            </ul>
        </>
    );
}

export default SideNavBarHoverAdminMasters;
